
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-dinas/pelaksanaan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-dinas/pelaksanaan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-dinas/pelaksanaan"])
      });
    }
  